(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ParCurvePointOpen', ParCurvePointOpen);

    ParCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function ParCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/par-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
